module.exports = __webpack_public_path__ + "static/27-c747d60ca5af439d505da73a511205f4.png";